export function wait(dt) {
    return new Promise((resolve) => setTimeout(resolve, dt));
}
export function throttle(fn, delay) {
    let lastCall;
    let lastRan;
    return (...args) => {
        if (!lastRan) {
            fn(...args);
            lastRan = Date.now();
        }
        else {
            clearTimeout(lastCall);
            lastCall = setTimeout(() => {
                if (Date.now() - lastRan >= delay) {
                    fn(...args);
                    lastRan = Date.now();
                }
            }, delay - (Date.now() - lastRan));
        }
    };
}
//# sourceMappingURL=async.util.js.map